import { Breadcrumb } from '../../types';

export const eventsBreadcrumbs: Map<string, Breadcrumb> = new Map([
	[
		'eventDraft',
		{
			name: 'eventDaft',
			to: '/events/draft',
			i18nKey: 'breadcrumb.eventDraft',
		},
	],
	[
		'eventCurrent',
		{
			name: 'eventCurrent',
			to: '/events/current',
			i18nKey: 'breadcrumb.eventCurrent',
		},
	],
	[
		'eventAll',
		{
			name: 'eventAll',
			to: '/events/all',
			i18nKey: 'breadcrumb.eventAll',
		},
	],
	[
		'serviceHoursScanProfile',
		{
			name: 'serviceHoursScanProfile',
			to: '/events/attendance',
			i18nKey: 'breadcrumb.serviceHoursScanProfile',
		},
	],
	[
		'eventAttendance',
		{
			name: 'eventAttendance',
			to: '/events/attendance',
			i18nKey: 'breadcrumb.eventAttendance',
		},
	],
	[
		'eventAttendanceScanProfile',
		{
			name: 'eventAttendanceScanProfile',
			to: '/events/attendance',
			i18nKey: 'breadcrumb.eventAttendanceScanProfile',
		},
	],
	[
		'eventTicketing',
		{
			name: 'eventTicketing',
			to: '/events/attendance/ticketing',
			i18nKey: 'breadcrumb.eventTicketing',
		},
	],
	[
		'eventTicketingQrCodeScanner',
		{
			name: 'eventTicketingQrCodeScanner',
			i18nKey: 'breadcrumb.eventTicketingQrCodeScanner',
		},
	],
	[
		'eventAttendanceAllTimeslots',
		{
			name: 'eventAttendanceAllTimeslots',
			i18nKey: 'breadcrumb.eventAttendanceAllTimeslots',
		},
	],
	[
		'eventAttendanceAttendanceList',
		{
			name: 'eventAttendanceAttendanceList',
			i18nKey: 'breadcrumb.eventAttendanceAttendanceList',
		},
	],
	[
		'eventApplications',
		{
			name: 'eventApplications',
			to: '/events/applications/list',
			i18nKey: 'breadcrumb.eventApplications',
		},
	],
	[
		'eventAttendanceQrCodeScanner',
		{
			name: 'eventAttendanceQrCodeScanner',
			i18nKey: 'breadcrumb.eventAttendanceQrCodeScanner',
		},
	],
	[
		'addEventApplication',
		{
			name: 'addEventApplication',
			i18nKey: 'breadcrumb.addEventApplication',
		},
	],
	[
		'addEventApplicationContactSearch',
		{
			name: 'addEventApplicationContactSearch',
			i18nKey: 'breadcrumb.addEventApplicationContactSearch',
		},
	],
	[
		'eventApplicationScanProfile',
		{
			name: 'eventApplicationScanProfile',
			i18nKey: 'breadcrumb.eventApplicationScanProfile',
		},
	],
	[
		'eventAttendanceImport',
		{
			name: 'eventAttendanceImport',
			i18nKey: 'breadcrumb.eventAttendanceImport',
		},
	],
	[
		'eventAttendanceImportContactSearch',
		{
			name: 'eventAttendanceImportContactSearch',
			i18nKey: 'breadcrumb.eventAttendanceImportContactSearch',
		},
	],
	[
		'eventAttendanceImportContactSelect',
		{
			name: 'eventAttendanceImportContactSelect',
			i18nKey: 'breadcrumb.eventAttendanceImportContactSelect',
		},
	],
	[
		'eventTicketingRedeem',
		{
			name: 'eventTicketingRedeem',
			i18nKey: 'breadcrumb.eventTicketingRedeem',
		},
	],
]);
